export class DeepObjectTransformer {

  removeUndefinedAndNullValues(obj) {
    if (obj && typeof obj === "object")
      return Object.entries(obj)
        .filter(([, v]) => ![undefined, null].includes(v))
        .reduce((r, [key, value]) => ({...r, [key]: this.removeUndefinedAndNullValues(value)}), {})
    else
      return obj
  }
}
